var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75561 15.2367C11.9057 15.2367 14.4593 12.683 14.4593 9.53295C14.4593 6.38288 11.9057 3.82925 8.75561 3.82925C5.60554 3.82925 3.0519 6.38288 3.0519 9.53295C3.0519 12.683 5.60554 15.2367 8.75561 15.2367ZM8.75561 16.6626C12.6932 16.6626 15.8852 13.4705 15.8852 9.53295C15.8852 5.59536 12.6932 2.40332 8.75561 2.40332C4.81802 2.40332 1.62598 5.59536 1.62598 9.53295C1.62598 13.4705 4.81802 16.6626 8.75561 16.6626Z",
    fill: "#33383F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20199 10.3054C5.56281 10.1478 5.98311 10.3125 6.14076 10.6733C6.58149 11.682 7.58729 12.3847 8.75563 12.3847C9.92396 12.3847 10.9298 11.682 11.3705 10.6733C11.5281 10.3125 11.9484 10.1478 12.3093 10.3054C12.6701 10.4631 12.8348 10.8834 12.6771 11.2442C12.0177 12.7535 10.5109 13.8106 8.75563 13.8106C7.00036 13.8106 5.49357 12.7535 4.83411 11.2442C4.67646 10.8834 4.84116 10.4631 5.20199 10.3054Z",
    fill: "#33383F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61672 7.39412C6.61672 7.78787 6.29752 8.10708 5.90376 8.10708C5.51 8.10708 5.1908 7.78787 5.1908 7.39412C5.1908 7.00036 5.51 6.68115 5.90376 6.68115C6.29752 6.68115 6.61672 7.00036 6.61672 7.39412Z",
    fill: "#33383F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3205 7.39412C12.3205 7.78787 12.0013 8.10708 11.6075 8.10708C11.2137 8.10708 10.8945 7.78787 10.8945 7.39412C10.8945 7.00036 11.2137 6.68115 11.6075 6.68115C12.0013 6.68115 12.3205 7.00036 12.3205 7.39412Z",
    fill: "#33383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiPicker);
export default __webpack_public_path__ + "static/media/emoji_picker.8da53cea8ca7d89893f8a93e9885be2f.svg";
export { ForwardRef as ReactComponent };